import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 168 154"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#D9D9D9",
      d: "M0 .002.095 0a9.06 9.06 0 0 1 6.622 2.877l126.441 136c5.354 5.759 1.264 15.123-6.605 15.123H168a13.03 13.03 0 0 1-9.633-4.255L34.216 13.382C29.537 8.242 33.189 0 40.145 0H0z"
    }, null, -1)
  ])))
}
export default { render: render }